// @ts-nocheck

import StoreRegistry from 'infrastructure/js/utils/StoreRegistry';
import * as aiAssistantService from '../../services/AiAssistant/aiAssistantService';
import * as assistantLocalStorage from '../../utils/AiAssistant/aiAssistantStorage';
import {api as aiAssistantFeedbackDialogApi} from './aiAssistantFeedbackDialogActions';

export const actionTypes = {
  AI_ASSISTANT__SHOW_SIDE_PANEL: 'AI_ASSISTANT__SHOW_SIDE_PANEL',
  AI_ASSISTANT__HIDE_SIDE_PANEL: 'AI_ASSISTANT__HIDE_SIDE_PANEL',
  AI_ASSISTANT__SHOW_SIDE_POPUP: 'AI_ASSISTANT__SHOW_SIDE_POPUP',
  AI_ASSISTANT__HIDE_SIDE_POPUP: 'AI_ASSISTANT__HIDE_SIDE_POPUP',
  AI_ASSISTANT__ADD_MESSAGE: 'AI_ASSISTANT__ADD_MESSAGE',
  AI_ASSISTANT__SET_LOADING: 'AI_ASSISTANT__SET_LOADING',
  AI_ASSISTANT__CLEAR_MESSAGES: 'AI_ASSISTANT__CLEAR_MESSAGES',
  AI_ASSISTANT__LOAD_MESSAGES: 'AI_ASSISTANT__LOAD_MESSAGES',
  AI_ASSISTANT__START_STREAMING: 'AI_ASSISTANT__START_STREAMING',
  AI_ASSISTANT__APPEND_CHUNK: 'AI_ASSISTANT__APPEND_CHUNK',
  AI_ASSISTANT__FINISH_STREAMING: 'AI_ASSISTANT__FINISH_STREAMING',
  AI_ASSISTANT__SET_STATUS: 'AI_ASSISTANT__SET_STATUS',
  AI_ASSISTANT__SET_MESSAGE_FEEDBACK: 'AI_ASSISTANT__SET_MESSAGE_FEEDBACK',
};

const actions = {
  showSidePanel: function () {
    return { type: actionTypes.AI_ASSISTANT__SHOW_SIDE_PANEL };
  },
  hideSidePanel: function () {
    return { type: actionTypes.AI_ASSISTANT__HIDE_SIDE_PANEL };
  },
  showSidePopup: function () {
    return { type: actionTypes.AI_ASSISTANT__SHOW_SIDE_POPUP };
  },
  hideSidePopup: function () {
    return { type: actionTypes.AI_ASSISTANT__HIDE_SIDE_POPUP };
  },
  addMessage: function (message) {
    return { type: actionTypes.AI_ASSISTANT__ADD_MESSAGE, payload: message };
  },
  setLoading: function (loading) {
    return { type: actionTypes.AI_ASSISTANT__SET_LOADING, payload: loading };
  },
  clearMessages: function () {
    return { type: actionTypes.AI_ASSISTANT__CLEAR_MESSAGES };
  },
  loadMessages: function (messages) {
    return { type: actionTypes.AI_ASSISTANT__LOAD_MESSAGES, payload: messages };
  },
  startStreaming: function (id, timestamp) {
    return { type: actionTypes.AI_ASSISTANT__START_STREAMING, payload: { id, timestamp } };
  },
  appendChunk: function (chunk) {
    return { type: actionTypes.AI_ASSISTANT__APPEND_CHUNK, payload: chunk };
  },
  finishStreaming: function () {
    return { type: actionTypes.AI_ASSISTANT__FINISH_STREAMING };
  },
  setStatus: function (message) {
    return { type: actionTypes.AI_ASSISTANT__SET_STATUS, payload: message };
  },
  setMessageFeedback: function (index, feedbackType) {
    return { type: actionTypes.AI_ASSISTANT__SET_MESSAGE_FEEDBACK, payload: { index, feedbackType } };
  },
};

export let api = {};

api.showSidePanel = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.showSidePanel());
};

api.hideSidePanel = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.hideSidePanel());
};

api.setMessageFeedback = function (index, feedbackType) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();
  dispatch(actions.setMessageFeedback(index, feedbackType));
  assistantLocalStorage.saveMessages(getState().aiAssistant.get('messages'));
};

api.showFeedbackDialog = function (data) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  aiAssistantFeedbackDialogApi.show(dispatch, getState)(data);
};


api.showSidePopup = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.showSidePopup());
};

api.hideSidePopup = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.hideSidePopup());
};

api.toggleSidePopup = function () {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();
  let state = getState().aiAssistant;

  if (state.get('showSidePopup')) {
    dispatch(actions.hideSidePopup());
    return;
  }

  dispatch(actions.showSidePopup());
};

api.toggleSidePanel = function () {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();
  let state = getState().aiAssistant;

  if (state.get('showSidePanel')) {
    dispatch(actions.hideSidePanel());
    return;
  }

  dispatch(actions.showSidePanel());
};

/**
 * Starts a new chat session by clearing messages and regenerating session ID.
 * Called on logout or when user manually starts a new chat.
 */
api.startNewChat = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();

  assistantLocalStorage.clearMessages();
  assistantLocalStorage.regenerateSessionId();

  dispatch(actions.clearMessages());
};

/**
 * Clears only Redux state, preserving LocalStorage.
 * Called on logout to clear in-memory state while keeping chat history persisted.
 */
api.clearReduxMessages = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  dispatch(actions.clearMessages());
};

/**
 * Loads messages from LocalStorage into Redux state.
 * Called after successful login to restore chat history.
 */
api.loadMessages = function () {
  let { dispatch } = StoreRegistry.getDefaultStore();
  const messages = assistantLocalStorage.loadMessages();
  dispatch(actions.loadMessages(messages));
};


api.sendMessage = async function (text) {
  let { dispatch, getState } = StoreRegistry.getDefaultStore();

  const userMsgId = Date.now();
  dispatch(actions.addMessage({
    id: userMsgId,
    role: 'user',
    text,
    timestamp: userMsgId,
  }));

  assistantLocalStorage.saveMessages(
    getState().aiAssistant.get('messages')
  );

  dispatch(actions.setLoading(true));


  const streamMsgId = Date.now() + 1;
  dispatch(actions.startStreaming(streamMsgId, Date.now()));

  let doneDispatched = false;
  const finishUp = () => {

    if (doneDispatched) {
      return;
    }

    doneDispatched = true;

    dispatch(actions.finishStreaming());
    dispatch(actions.setLoading(false));

    assistantLocalStorage.saveMessages(
      getState().aiAssistant.get('messages')
    );
  };


  try {

    const sessionId = assistantLocalStorage.loadSessionId();

    await aiAssistantService.sendMessageStream({
      prompt: text,
      sessionId,
      onChunk: (chunk) => dispatch(actions.appendChunk(chunk)),
      onStatus: (message) => dispatch(actions.setStatus(message)),
      onDone: finishUp,
      onError: (err) => {
        console.error('AI Assistant stream error:', err);
        finishUp();
      },
    });
  } catch (err) {
    console.error('AI Assistant error:', err);
    finishUp();
  }
};
